import {GET_DATA_PLANCONFIGBYSTEP_PLANTEMPLATE, SET_DATA_PLANCONFIGBYSTEP_PLANTEMPLATE} from '../actions/actionTypes'
import {RequertPlanConfigByStepPlanTemplateFaileAction, GetDataPlanConfigByStepPlanTemplateSuccessAction, IsResultAction } from '../actions'

import { put, takeLatest} from 'redux-saga/effects'
import { Api } from './api'

function* GetDataPlanConfigByStep(action){
    try{
        const DataPlanConfigByStep = yield Api.GetDataPlanConfigByStepFromApi(action.id, action.stepNumberPerform);
        yield put(GetDataPlanConfigByStepPlanTemplateSuccessAction(DataPlanConfigByStep))
    }catch(error){
        yield put(RequertPlanConfigByStepPlanTemplateFaileAction(error))
    }
}
export function* watchGetDataPlanConfigByStep(){
    yield takeLatest(GET_DATA_PLANCONFIGBYSTEP_PLANTEMPLATE, GetDataPlanConfigByStep)
}

function* SetDataPlanConfigByStep(action){
    try{
        const isResult = yield Api.SetDataPlanConfigByStepFromApi(action.DataPlanConfigByStep);
        yield put(IsResultAction(isResult));
    }catch(error){
        yield put(RequertPlanConfigByStepPlanTemplateFaileAction(error))
    }
}
export function* watchSetDataPlanConfigByStep(){
    yield takeLatest(SET_DATA_PLANCONFIGBYSTEP_PLANTEMPLATE, SetDataPlanConfigByStep)
}